module.exports = __webpack_public_path__ + "static/media/Door Left Hand Closed.d7cdc3e3.svg";